<template>
  <div class="px-box-2 sm:px-box-4 pb-16 md:pb-32">
    <AppRating class="mt-8" />
    <div
      class="flex-wrap gap-x-6 gap-y-4 md:gap-x-8 justify-center py-12 md:pt-10 md:pb-14"
      :class="hideProviderLogosMobile ? 'hidden md:flex' : 'flex'"
    >
      <img
        v-for="provider in HERO_PROVIDERS"
        :key="provider.name"
        class="block h-8"
        :src="provider.logo"
        :alt="provider.name"
      />
    </div>
    <ul
      class="featured-blocks relative mt-28 md:mt-16 max-w-screen-xl mx-auto flex flex-col md:flex-row justify-center"
    >
      <li
        class="bg-white rounded-12 shadow-2 flex-1 mb-8 px-8 py-7 sm:mx-20 md:mx-2 lg:mx-4 lg:w-1/4 lg:max-w-sm"
        v-for="(block, index) in blocks"
        :key="`block-${index}`"
      >
        <div v-if="block.icon && block.icon.url" class="w-12 h-12 mx-auto">
          <MImage :src="block.icon.url" :alt="block.icon.alt" :lazy="false" />
        </div>
        <PortableText class="typography text-center text-18" :content="block.text" />
      </li>
    </ul>
    <div v-if="featuredOn" class="lead text-center mt-16">
      {{ $t('as_featured_on') }}
    </div>
    <div v-if="featuredOn" class="flex flex-wrap justify-center sm:mx-20 md:mx-40 mt-4">
      <Component
        v-for="(item, index) in featuredOn"
        :key="index"
        :is="item.link ? 'a' : 'span'"
        :href="item.link ?? undefined"
      >
        <MImage
          v-if="item.logo?.url"
          class="h-12"
          :src="item.logo.url"
          :alt="item.logo.alt"
          :lazy="false"
        />
      </Component>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { GQLBlock } from '@core/types/generated/text'

const HERO_PROVIDERS = [
  {
    name: 'Remitly',
    logo: 'https://monito.imgix.net/psp/remitly-new.png?w=400&auto=compress,format',
  },
  {
    name: 'Wise',
    logo: 'https://monito.imgix.net/psp/wise-green-logo.png?w=400&auto=compress,format',
  },
  {
    name: 'PayPal',
    logo: 'https://monito.imgix.net/psp/paypal-transparent-logo.png?w=400&auto=compress,format',
  },
  {
    name: 'WorldRemit',
    logo: 'https://monito.imgix.net/psp/worldremit-logo-oct2020.png?w=200&auto=compress,format',
  },
  {
    name: 'Western Union',
    logo: 'https://monito.imgix.net/psp/western-union-yellow-black.png?w=400&auto=compress,format',
  },
] as const

defineProps<{
  blocks: Array<{
    icon: { url: string | null; alt: string | null } | null
    text: GQLBlock[]
  }>
  featuredOn: Array<{
    link: string | null
    logo: { url: string | null; alt: string | null } | null
  }> | null
  hideProviderLogosMobile?: boolean
}>()
</script>

<style scoped>
.featured-blocks::before {
  content: '';
  background-image: url('./images/mascot.png');
  @apply h-32 w-32 bg-bottom bg-no-repeat bg-contain absolute bottom-full -mb-5;
  @apply -translate-x-1/2 sm:translate-x-1/2 md:translate-x-0 left-1/2 md:left-3/4;
}
</style>
